<!-- <h1>timeout : {{timedOut}}</h1> -->
<div>
<router-outlet (activate)="ChangeRouteName($event)"></router-outlet>
</div>
<!-- <app-menu (Toggle)="ToggleMenu($event)" [MenuName]="MenuName" [DisplayMenu]="DisplayMenu"
    *ngIf="ShowElement && DisplayMenu"></app-menu>
<app-footer [DisplayMenu]="DisplayMenu" (Toggle)="ToggleMenuFromFooter($event)" *ngIf="ShowElement"></app-footer> -->

<app-notification></app-notification>

<!-- <div> -->
<div *ngIf="showTimeoutModal==true">
    <div class="popup-bg">
    </div>

    <div class="popup-position container-fluid p-0">
        <div class="white mystats in">
            <div class="row">
                <div class="col-md-11 popup-header">
                    <p>
                        Session Timeout
                    </p>
                </div>
                <div class="col-md-1 popup-header closeIcon">
                    <i title="Close Session Timeout" class="fa fa-close" (click)="stay()"></i>
                </div>
                <div class="col-md-12">
                    <h3>Your session will expire in : {{idleState}}</h3>
                    <p>Please close the pop-up within 10 seconnds to avoid session timeout</p>
                </div>
            </div>
        </div>
    </div>
</div>